/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";

import { Button, Tab, Tabs, Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";

import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";

import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import CircularLoader from "../../../shared/loader/CircularLoader";
import { AuthContext, UIContext } from "../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import useRouteParam from "../../../../hooks/useRouteParam";
import { GROUP_NUMBER } from "../../../../constants/groups";
import GroupIcon from "@material-ui/icons/Group";
import { api } from "../../../../utils/api";
import { PaginationQuery } from "../../../../@types/pagination.types";
import { Group } from "../../../../@types/group.types";
import { GridApi } from "ag-grid-community";
import GroupManagementGrid from "./groupManagementGrid/GroupManagementGrid";

const GreenSwitch = withStyles({
	switchBase: {
		color: "#359a4c",
		"&$checked": {
			color: "#359a4c"
		},
		"&$checked + $track": {
			backgroundColor: "rgba(40, 167, 69, 0.8)"
		}
	},
	checked: {},
	track: {
		backgroundColor: "rgb(60, 179, 113)"
	}
})(Switch);

const TabPanel = (props: any) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
};

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

const a11yProps = (index: any) => {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
};

const GroupManagement = () => {
	const [planCheckedStatus, setPlanCheckedStatus] = useState(false);
	const [coreActivePlans, setCoreActivePlans] = useState([]);
	const [loading, setLoading] = useState(true);
	const [inActivePlans, setInActivePlans] = useState([]);
	const [expiredPlans, setExpiredPlans] = useState([]);
	const [value, setValue] = useState(0);
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");
	const [groups, setGroups] = useState<Group[]>([]);
	const [assignedGroups, setAssignedGroups] = useState([]);
	const { user } = useContext(AuthContext);
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const navigate = useNavigate();

	const handlePlanSwitchClick = (event: any) => {
		const { checked } = event.target;

		setPlanCheckedStatus(checked);
	};

	// const getPlans = useCallback(
	// 	async (planCheckedStatus) => {
	// 		setLoading(true);
	// 		try {
	// 			let plans;
	// 			const planQuery = { group_number: queryGroupNumber };

	// 			// console.log("planCheckStatus (getPlans)", planCheckedStatus);

	// 			if (planCheckedStatus) {
	// 				plans = await trackPromise(api.plan.getVEBPlans(planQuery));
	// 			} else {
	// 				plans = await trackPromise(api.plan.getPlans(planQuery));
	// 			}

	// 			// console.log("Plans===>", plans);

	// 			const _activePlans = plans.filter((plan) => {
	// 				return plan.status === "ACTIVE";
	// 			});
	// 			// console.log("_activePlans==>", _activePlans);
	// 			// console.log("_activePlans==>", _activePlans[0]?.end_date);
	// 			setCoreActivePlans(Object.assign([], _activePlans));

	// 			const _inactivePlans = plans.filter((plan) => {
	// 				return plan.status === "INACTIVE";
	// 			});
	// 			// console.log("_inactivePlans==>", _inactivePlans);
	// 			// console.log("_inactivePlans==>", _inactivePlans[0]?.end_date);
	// 			setInActivePlans(Object.assign([], _inactivePlans));

	// 			const _expiredPlans = plans.filter((plan) => {
	// 				return plan.status === "EXPIRED";
	// 			});
	// 			setExpiredPlans(Object.assign([], _expiredPlans));
	// 		} catch (error) {
	// 			console.error("Error fetching plans:", error);
	// 		} finally {
	// 			setLoading(false);
	// 		}
	// 	},
	// 	[queryGroupNumber, planCheckedStatus]
	// );

	const getAssignGroups = useCallback(async () => {
		const params = {
			user_id: user?._id
		};
		console.log("param========>", params);
		const response = await trackPromise(api.assignGroupsAndLocation.getAssignedGroupsAndLocations(params));

		console.log("response=========>", response.groupsAndLocations);

		if (response) {
			const _assignedGroups: any[] = [];
			response.groupsAndLocations.forEach((group: any) => {
				if (group.assigned_group_info) {
					_assignedGroups.push(group);
				}
			});

			setAssignedGroups(Object.assign([], _assignedGroups));
		}
	}, [user?._id]);

	const getGroups = useCallback(async () => {
		const paginationQuery: PaginationQuery = {
			page: 1,
			limit: 3000
		};
		const paginatedResult = await trackPromise(api.assignGroupsAndLocation.getAssignedGroups(paginationQuery));
		setGroups(Object.assign([], paginatedResult.groups));
		agGridAPI?.refreshCells();
	}, [agGridAPI]);

	const handleClickCreateGroup = () => {
		navigate("/create-group");
	};

	const handleLabelChange = (event: any, value: any) => {
		setValue(value);
	};

	const handleAddCorePlanClick = () => {
		const pathname = `/employer/plan/create-core-plan?gn=${queryGroupNumber}`;
		navigate(pathname);
	};

	const handleAddVebPlanClick = () => {
		const pathname = `/employer/plan/create-veb-plan?gn=${queryGroupNumber}`;
		navigate(pathname);
	};

	useEffect(() => {
		if (queryGroupNumber) {
			// // console.log("queryGroupNumber", queryGroupNumber);
			// getPlans(planCheckedStatus);
		}
		getAssignGroups();
		getGroups();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_group);
	}, [setDashboardHeader, getAssignGroups, getGroups, queryGroupNumber]);

	return (
		<div className="plan-management-container">
			<div className="pf-action-button-container" id="pf-action-button-container">
				<Button className="button-green" variant="contained" onClick={handleClickCreateGroup}>
					<span className="button-label-with-icon">Create Group</span>
					<span>
						<GroupIcon className="button-icon" />
					</span>
				</Button>
			</div>
			<div className="all-location-tab-container">
				{/* {loading && <CircularLoader />} */}
				<Box sx={{ width: "100%" }}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs
							value={value}
							onChange={handleLabelChange}
							aria-label="basic tabs example"
							TabIndicatorProps={{
								style: {
									border: "none",
									backgroundColor: "#558b2f"
								}
							}}
							className="glb-tab-panel"
						>
							<Tab label={"Active Groups"} className="glb-tab-label" {...a11yProps(0)} />
							<Tab label={"Inactive Groups"} className="glb-tab-label" {...a11yProps(1)} />
							{/* <Tab label={"History"} className="glb-tab-label" {...a11yProps(1)} /> */}
						</Tabs>
					</Box>

					<TabPanel value={value} index={0}>
						{/* <GroupManagementGrid /> */}
					</TabPanel>
					<TabPanel value={value} index={1}>
						{/* <GroupManagementGrid /> */}
					</TabPanel>
					{/* <TabPanel value={value} index={1}>
						<PlanManagementGrid gridProps={expiredPlans} tabLabel={"history"} />
					</TabPanel> */}
				</Box>
			</div>
		</div>
	);
};

export default GroupManagement;
